import React from "react";
import { Select } from "antd";

export interface Option {
  value: string;
  label: string;
}

export interface MultiSelectWithTagsProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  options: Option[];
  disabled?: boolean;
  loading?: boolean;
  placeholder?: string;
  className?: string;
  tagColor?: string;

  [key: string]: any;
}

const MultiSelectWithTags: React.FC<MultiSelectWithTagsProps> = ({
  value = [],
  onChange,
  options,
  disabled,
  loading,
  placeholder = "Search...",
  className = "",
  tagColor = "#ff9f1c",
  ...props
}) => {
  const handleSelect = (selected: string) => {
    if (!value.includes(selected)) {
      const newValue = [...value, selected];
      onChange?.(newValue);
    }
  };

  const handleRemove = (removed: string) => {
    const newValue = value.filter((v) => v !== removed);
    onChange?.(newValue);
  };

  return (
    <>
      <Select
        showSearch
        placeholder={placeholder}
        className={className}
        // filterOption={false}
        value={null}
        options={options}
        disabled={disabled}
        loading={loading}
        onChange={handleSelect}
        {...props}
      />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {value.map((selected) => {
          const opt = options.find((o) => o.value === selected);
          if (!opt) return null;
          return (
            <span
              key={selected}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: tagColor,
                color: "#fff",
                padding: "6px 18px 6px 12px",
                borderRadius: 16,
                fontSize: 14,
                fontWeight: 500,
                position: "relative",
              }}
            >
              {opt.label}
              <button
                onClick={() => handleRemove(selected)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#fff",
                  marginLeft: 6,
                  cursor: "pointer",
                  fontSize: 16,
                  borderRadius: "50%",
                  width: 22,
                  height: 22,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.2s",
                }}
                title={`Remove ${opt.label}`}
              >
                x
              </button>
            </span>
          );
        })}
      </div>
    </>
  );
};

export default MultiSelectWithTags;
